<template>
  <div class="bb-table-date">
    <template v-if="column.editable && row.openEdit">
      <DataPicker font-size="14"
                  @setDate="setDate"
                  :default-date="getProp(row, column)"
                  :obj="{row: row, column: column}"
      />
    </template>
    <template v-else>
      <i class="bb-table-date__icon" v-if="withIcon"
         :class="[
           'icon-' + iconDate.icon,
           'bb-table-date__icon_' + iconDate.style
         ]"
      />
      <template v-if="isDiff">
        {{differenceDates}}
      </template>
      <template v-else-if="!value">
        <div class="bb-table-date-placeholder">
          <span>{{column.placeholder}}</span>
          <div class="bb-table-date-icons"
               ref="commentText"
               v-if="displayComment.display"
          >
            <i class="icon-info bb-table-date__icon-comment"
               @mouseenter="setPositionPopup($event, row._id, 'commentText')"
               @mouseleave="showComment = false"/>
            <transition name="fade" mode="out-in">
              <div v-if="showComment === row._id"
                   :style="openPopup"
                   class="bb-table-date-popup"
              >
                <span class="bb-table-date-popup__text">{{displayComment.text}}</span>
              </div>
            </transition>
          </div>
        </div>
      </template>
      <div v-else>
        {{value}}
      </div>
    </template>
  </div>
</template>

<script>
import _, {get, reduce} from 'lodash'
import moment from 'moment'
import DataPicker from '@/components/Main/DataPicker/DataPicker'

export default {
  name: 'BBDateCell',
  props: ['row', 'column', 'index'],
  components: {
    DataPicker
  },
  data () {
    return {
      showComment: false,
      openPopup: {
        left: 0,
        top: 0
      }
    }
  },
  computed: {
    withIcon () {
      return get(this.column, 'iconDate', '')
    },
    iconDate () {
      const val = this.duration ? this.duration.asMilliseconds() : ''
      const getIcon = get(this.column, 'iconDate', () => {})
      return val ? getIcon(val) || {} : ''
    },
    isDiff () {
      const type = get(this.column, 'dateType', '')
      return type === 'diff' || type === 'calcDiff'
    },
    value () {
      const date = get(this.row, this.column.prop, '')
      return this.formatDate(date)
    },
    calcDiff () {
      const diffVal = get(this.row, this.column.prop, 0)
      const total = get(this.row, this.column.total, 1) || 1
      return diffVal / total
    },
    displayComment () {
      const prop = get(this.column, 'info.display', '')
      const propText = get(this.column, 'info.text', '')
      const valueDisplay = get(this.row, prop, '')
      const valueText = get(this.row, propText, '')
      return {
        display: valueDisplay,
        text: valueText
      }
    },
    duration () {
      const diffMilliseconds = get(this.column, 'dateType', '') === 'calcDiff'
      if (diffMilliseconds) return moment.duration(this.calcDiff)
      const startDateProp = get(this.column, ['datesProp', 'start'], '')
      const endDateProp = get(this.column, ['datesProp', 'end'], '')
      const startDate = moment(get(this.row, startDateProp, ''))
      const endDate = moment(get(this.row, endDateProp, ''))
      if (!startDate.isValid() || !endDate.isValid()) return ''
      const diff = endDate.diff(startDate)
      return moment.duration(diff)
    },
    differenceDates () {
      if (!this.duration) return ''
      const dur = this.duration
      const values = {
        yrs: dur.years(),
        months: dur.months(),
        days: dur.days(),
        hr: dur.hours(),
        min: dur.minutes(),
        sec: dur.seconds()
      }
      return reduce(values, (sum, item, key) => {
        const val = Math.abs(item)
        if (val !== 0) sum += `${val} ${key} `
        return sum
      }, '')
    },
    formatValue () {
      return get(this.column, 'formatDate', 'DD-MMM-YYYY')
    }
  },
  methods: {
    formatDate (date) {
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format(this.formatValue) : ''
    },
    setDate (date) {
      this.$set(this.row, 'approvedDate', date)
    },
    setPositionPopup (e, rowId, ref) {
      if (ref === 'commentText') this.showComment = rowId
      const popups = get(this.$refs, ref, '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.openPopup = {
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    },
    getProp (row, column) {
      const value = _.get(row, column.prop, '')
      if (column.type === 'date') {
        return this.formatDate(value, column)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-table-date {
  @include global-font;
  display: inline-block;
  padding: 7px 8px;
  margin: -7px 0 -7px -8px;
  border-radius: 3px;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;

  &-placeholder {
    display: flex;
    align-items: center;
  }

  &-icons {
    margin: auto 0 auto 5px;
  }

  &__icon-comment {
    cursor: pointer;
    color: $color-silver-chalice;
  }

  &-popup {
    display: grid;
    z-index: 2;
    grid-row-gap: 10px;
    max-width: 458px;
    position: fixed;
    background: $color-white;
    box-shadow: 0 0 12px rgba($color-black, 0.12);
    border-radius: 5px;
    color: black;
    padding: 12px;
    pointer-events: none;

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    font-size: 12px;
    margin-right: 4px;

    &:before {
      margin: 0;
    }

    &_red {
      color: $color-pomegranate
    }

    &_green {
      color: $color-japanese-laurel
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/DateCell/DateCell.vue